import React, { Component } from 'react';
import {connect} from 'react-redux';
import { capitalize } from 'lodash';
import {history} from '../../../../../store';
import Datatable from '../../../../../components/common/datatable/index';
import Can from '../../../../../components/common/guards/can';

class ScansTable extends Component {
  render() {
    const {
      scans, currentPage, onPageChange, paging
    } = this.props;
    const dataToDisplay = (scans || []);
    const actions = [
      (index, row) => (
        <div>
          <Can action='manage-scans' subjectClass='manage_scans'>
            <a
              href={`/admin/scans/${row.id}`}
              className="red-ghost-btn btn btn-default"
            >
              View Scan
            </a>
          </Can>
        </div>
      )
    ];

    const columns = [
      {
        prop: 'created-at',
        title: 'Scan date'
      },
      {
        prop: 'customer-number',
        title: 'Customer number'
      },
      {
        prop: 'user-id',
        title: 'User ID',
        onClick: (cell, row) => {
          const userEditPath = row.attributes['is-owner-or-staff'] ? 'details' : 'edit';
          history.push(`/admin/users/${row.attributes['user-id']}/${userEditPath}`);
        }
      },
      {
        prop: 'product-code',
        title: 'Product code (EAN)',
        onClick: (cell, row) => {
          history.push(`/admin/products/${row.attributes['product-id']}`);
        }
      },
      {
        prop: 'outer-code',
        title: 'Outer Code'
      },
      {
        prop: 'valid-scan',
        title: 'Valid',
        format: data => (data === true ? 'Y' : 'N')
      },
      {
        prop: 'fail-reason',
        title: 'Fail Reason',
        format: data => capitalize(data)
      },
    ];

    return (
      <div>
        <div className="mg-bottom-30">
        </div>
        <Datatable
          data={dataToDisplay}
          columns={columns}
          actions={actions}
          hideId={false}
          remote
          dataSize={paging ? paging.number * paging.size : dataToDisplay.length}
          pagination={{
            page: currentPage,
            sizePerPage: 20,
            onPageChange,
          }}
        />
      </div>
    );
  }
}

export default connect()(ScansTable);



// WEBPACK FOOTER //
// ./src/components/admin/scans/scans/list/scans-table.jsx